import tinycolor from 'tinycolor2';

var unsupportedTags = ['filter'];

module.exports = function (svg, content, options) {
  convertStyleTags(svg, content, options);
  convertInlinedStyle(svg);

  return svg;
};

function convertInlinedStyle (svg) {
  $(svg).find('[style]').each(function () {
    var inlinedStyles = _.map(this.style, function (styleName) { return styleName; });

    _.each(inlinedStyles, function (styleName) {
      var $elem = $(this);
      var styleValue = $elem.css(styleName);

      if (_.includes(['fill', 'stroke'], styleName) && styleValue !== 'none') {
        styleValue = tinycolor(styleValue).toHexString();
      }

      $elem.css(styleName, '');
      unsupportedTags.indexOf(styleName) === -1
        && styleValue && $elem.attr(styleName, styleValue);
    }, this);
  });
}

function convertStyleTags (svg, content, options) {
  try {
    var $svg = $(svg);
    var $styles = $(content).find('style');

    _.chain($styles)
      .map(getStyleSheet)
      .each(inlineStyleSheet);

    _.each($styles, function (s) { document.head.removeChild(s); });

    options.keepClasses || $svg.find('[class]').removeAttr('class');
  } catch (error) {
    console.error('convertStyleTags: ', error);
  }

  function inlineStyleSheet (sheet) {
    _.each(sheet.cssRules, function (cssRule) {
      var $els = $svg.find(cssRule.selectorText);

      _.each(cssRule.style, function (styleName) {
        unsupportedTags.indexOf(styleName) === -1
          && $els.attr(styleName, cssRule.style[styleName]);
      }, this);
    });
  }
}

function getStyleSheet (style) {
  style.appendChild(document.createTextNode(''));
  document.head.appendChild(style);
  return style.sheet;
}
